module.exports = __webpack_public_path__ + "static/cfg-2-29273f1bcd3e27bbcd68220ed8538bfc.jpeg";